"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/features/promise");
var debug_1 = require("debug");
var axios_1 = require("axios");
var qs = require("qs");
var jsonp_1 = require("./jsonp");
var utils_1 = require("./utils");
var request_1 = require("./request");
var sendJSONP = function (req, getLatestRequestID) {
    var query = qs.stringify(req.body, { addQueryPrefix: true });
    var url = "" + req.url + query;
    return new Promise(function (resolve, reject) {
        debug_1.default('sdk:api:jsonp')('url: ', url);
        debug_1.default('sdk:api:jsonp')('options: ', req.options);
        jsonp_1.default(url, req.options, function (err, data) {
            if (getLatestRequestID() !== req.id)
                return;
            if (err) {
                reject(err);
            }
            else if (typeof data === 'object' && !(data instanceof Array)) {
                resolve(data);
            }
            else {
                resolve();
            }
        });
    });
};
var sendPOST = function (req) { return __awaiter(_this, void 0, void 0, function () {
    var headers, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                headers = {
                    'x-key': req.body.key,
                    'Content-type': 'application/json',
                };
                debug_1.default('sdk:api:post')('url: ', req.url);
                debug_1.default('sdk:api:post')('body: ', req.body);
                debug_1.default('sdk:api:post')('headers: ', headers);
                return [4, axios_1.default.post(req.url, req.body, { headers: headers })];
            case 1:
                response = _a.sent();
                debug_1.default('sdk:api:post')('response: ', response);
                return [2, response.data];
        }
    });
}); };
var request = (_a = {},
    _a[request_1.Method.POST] = sendPOST,
    _a[request_1.Method.JSONP] = sendJSONP,
    _a);
exports.send = function (req, getLatestRequestID) {
    return utils_1.retryTimes(req.retryCount, function () { return request[req.method](req, getLatestRequestID); });
};
//# sourceMappingURL=api.js.map